/**
 * PrivacyPolicySection Component
 * Long-form privacy policy content
 */

import { useTranslation } from "@/language"

export function PrivacyPolicySection() {
  const { t } = useTranslation("settings")

  return (
    <div className="flex flex-col gap-7.5">
      {/* Section Header */}
      <div>
        <h1 className="text-lg md:text-xl font-semibold text-primary uppercase section-heading">
          {t("privacyPolicy.title")}
        </h1>
        <p className="text-sm text-primary leading-6.25 mt-2.5 md:mt-1.25">
          {t("privacyPolicy.description")}
        </p>
      </div>

      {/* Policy Content */}
      <div className="flex flex-col gap-7.5">
        {/* Introduction */}
        <section className="flex flex-col gap-3.75">
          <h2 className="text-lg font-semibold text-primary">{t("privacyPolicy.introduction")}</h2>
          <p className="text-sm text-[#F2F0EBB3] leading-relaxed">
            {t("privacyPolicy.introDescription")}
          </p>
          <p className="text-sm text-[#F2F0EBB3] leading-relaxed">
            {t("privacyPolicy.introContent1")}
          </p>
          <p className="text-sm text-[#F2F0EBB3] leading-relaxed">
            {t("privacyPolicy.introContent2")}
          </p>
          <p className="text-sm text-[#F2F0EBB3] leading-relaxed">
            {t("privacyPolicy.introContent3")}
          </p>
        </section>

        {/* Information We Collect */}
        <section className="flex flex-col gap-3.75">
          <h2 className="text-lg font-semibold text-primary">
            {t("privacyPolicy.informationWeCollect")}
          </h2>
          <p className="text-sm text-[#F2F0EBB3] leading-relaxed">
            {t("privacyPolicy.informationContent1")}
          </p>

          <p className="text-sm text-[#F2F0EBB3] leading-relaxed">
            {t("privacyPolicy.informationContent2")}
          </p>
        </section>

        {/* How We Use Your Data */}
        <section className="flex flex-col gap-3.75">
          <h2 className="text-lg font-semibold text-primary">{t("privacyPolicy.howWeUseData")}</h2>
          <p className="text-sm text-[#F2F0EBB3] leading-relaxed">
            {t("privacyPolicy.useDataContent")}
          </p>
        </section>
      </div>
    </div>
  )
}
